// Shared styles for the search bar + filter button layout.
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useSearchStyles = createStyles({
  // Default min-width: auto on both so searchInput's 400px floor reaches the page-shell row's min-content.
  filtersContainer: { display: "flex", flexDirection: "column", gap: tokens.spacing[4], flex: "1 1 0" },
  search: { display: "flex", flexDirection: "row", alignItems: "center", gap: tokens.spacing[2] },
  // 400px floor — anything narrower lets the codex Input's single-line placeholder bleed past the wrapper.
  searchInput: {
    width: 400,
    minWidth: 400,
  },
  searchClearButton: {
    textDecoration: "none",
    padding: 0,
    border: "none",
  },
  // BillingView variant: a CSS Grid overlay lets a wrapping <span> stand in for the single-line native
  // placeholder. The grid cell sizes to whichever child is taller, so the input grows when the overlay wraps.
  searchInputWrap: {
    flex: "1 1 0",
    minWidth: 130,
    maxWidth: 400,
    display: "grid",
    "& > *": {
      gridColumn: 1,
      gridRow: 1,
    },
    // WARNING: substring-matches @blurb/codex-react's hashed CSS-module classes. A codex bump that renames
    // these will silently break BillingView's wrapping search — verify visually after any codex upgrade.
    "& [class*='Input-module__container']": {
      minWidth: 0,
    },
    "& [class*='Input-module__wrapper']": {
      minWidth: 0,
      minHeight: "100%",
      alignItems: "flex-start",
      paddingTop: 8,
    },
    "& input": {
      minWidth: 0,
    },
    // Hide the native placeholder; the overlay shows it. The real attribute stays for a11y + tests.
    "& input::placeholder": {
      color: "transparent",
    },
  },
  wrappingPlaceholder: {
    paddingLeft: 40,
    paddingRight: 8,
    paddingTop: 8,
    paddingBottom: 8,
    color: tokens.color.semantic.text.subtle,
    fontSize: 16,
    lineHeight: "20px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    pointerEvents: "none",
    alignSelf: "start",
  },
});
